var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSproutAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6121 7.2656C11.539 8.27658 11.3052 9.8291 11.273 10.7934H11.25V14.4148C11.2445 14.4183 11.2391 14.4219 11.2336 14.4254L2.46285 20.2015C1.5573 20.7978 2.06956 22 3.22924 22H20.7708C21.9304 22 22.4427 20.7978 21.5371 20.2015L12.7664 14.4254C12.761 14.4219 12.7555 14.4183 12.75 14.4148V11.6541C13.7527 11.5649 15.0629 11.2737 15.9658 10.423C17.0902 9.36366 17.2932 7.70965 17.3081 6.76095C17.315 6.32784 16.9599 5.99353 16.5 6.0001C15.4927 6.01448 13.7366 6.20622 12.6121 7.2656Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSproutAlt);
export default __webpack_public_path__ + "static/media/sprout-alt.8c9792b6e365764732277b06dae29e1f.svg";
export { ForwardRef as ReactComponent };